export enum SHIPPING_CONDITION_CODE {
  DELIVERY = '01',
  PICK_UP = '02',
  OWN_FREIGHT = '05',
  STANDARD = '06',
}

export enum SHIPPING_CONDITION_ALPHA_CODE {
  DELIVERY = 'DLVR',
  PICK_UP = 'PU',
  OWN_FREIGHT = 'OF',
  STANDARD = 'STD',
}

export const shippingConditionCodeToAlphaMap = new Map<SHIPPING_CONDITION_CODE, SHIPPING_CONDITION_ALPHA_CODE>([
  [SHIPPING_CONDITION_CODE.DELIVERY, SHIPPING_CONDITION_ALPHA_CODE.DELIVERY],
  [SHIPPING_CONDITION_CODE.PICK_UP, SHIPPING_CONDITION_ALPHA_CODE.PICK_UP],
  [SHIPPING_CONDITION_CODE.OWN_FREIGHT, SHIPPING_CONDITION_ALPHA_CODE.OWN_FREIGHT],
  [SHIPPING_CONDITION_CODE.STANDARD, SHIPPING_CONDITION_ALPHA_CODE.STANDARD],
]);

export type ShippingConditionsCodesTypes =
  | SHIPPING_CONDITION_CODE.DELIVERY
  | SHIPPING_CONDITION_CODE.PICK_UP
  | SHIPPING_CONDITION_CODE.OWN_FREIGHT
  | SHIPPING_CONDITION_CODE.STANDARD;
